
import { Link, useNavigate } from "react-router-dom";


export default function VehicleAccessoryTable() {
    const navigate = useNavigate();

    const handleNavigate = (vehicleno) => {
        navigate(`/${vehicleno}`);


    };
    const data = [
        { id: 2, vehicleno: "Safe Student", accessoryitem: "Side Mirror", quantity: "4", price: "$1000", purchasedate: "Thu Mar 2 2022" },
        { id: 3, vehicleno: "MH03AS3945", accessoryitem: "Side Mirror", quantity: "24", price: "$1000", purchasedate: "Thu Mar 2 2022" },
        { id: 4, vehicleno: "MH04KL0921", accessoryitem: "Side Mirror", quantity: "45", price: "$1000", purchasedate: "Thu Mar 2 2022" },
        { id: 1, vehicleno: "MH20ER4534", accessoryitem: "Side Mirror", quantity: "4", price: "$1000", purchasedate: "Thu Mar 2 2022" },
        { id: 1, vehicleno: "MH20ER4534", accessoryitem: "Side Mirror", quantity: "4", price: "$1000", purchasedate: "Thu Mar 2 2022" },
        { id: 1, vehicleno: "MH20ER4534", accessoryitem: "Side Mirror", quantity: "4", price: "$1000", purchasedate: "Thu Mar 2 2022" },
        { id: 1, vehicleno: "MH20ER4534", accessoryitem: "Side Mirror", quantity: "4", price: "$1000", purchasedate: "Thu Mar 2 2022" },
        { id: 1, vehicleno: "MH20ER4534", accessoryitem: "Side Mirror", quantity: "4", price: "$1000", purchasedate: "Thu Mar 2 2022" },
        { id: 1, vehicleno: "MH20ER4534", accessoryitem: "Side Mirror", quantity: "4", price: "$1000", purchasedate: "Thu Mar 2 2022" },
        { id: 1, vehicleno: "MH20ER4534", accessoryitem: "Side Mirror", quantity: "4", price: "$1000", purchasedate: "Thu Mar 2 2022" },
        { id: 1, vehicleno: "MH20ER4534", accessoryitem: "Side Mirror", quantity: "4", price: "$1000", purchasedate: "Thu Mar 2 2022" },
        { id: 1, vehicleno: "MH20ER4534", accessoryitem: "Side Mirror", quantity: "4", price: "$1000", purchasedate: "Thu Mar 2 2022" },
        { id: 5, vehicleno: "MH05MH5932", accessoryitem: "Side Mirror", quantity: "44", price: "$1245", purchasedate: "Thu Mar 2 2022" },
        { id: 6, vehicleno: "MH06MJ4321", accessoryitem: "Side Mirror", quantity: "4", price: "$3221", purchasedate: "Thu Mar 2 2022" },
        { id: 7, vehicleno: "MH07ND4567", accessoryitem: "Side Mirror", quantity: "5", price: "$2000", purchasedate: "Thu Mar 2 2022" },
        { id: 8, vehicleno: "MH08KK4909", accessoryitem: "Side Mirror", quantity: "3", price: "$2000", purchasedate: "Thu Mar 2 2022" },
        { id: 9, vehicleno: "MH11KL0008", accessoryitem: "Side Mirror", quantity: "11", price: "$2000", purchasedate: "Thu Mar 2 2022" },
        { id: 10, vehicleno: "MH20UI3424", accessoryitem: "Side Mirror", quantity: "12", price: "$2000", purchasedate: "Thu Mar 2 2022" },
        { id: 11, vehicleno: "MH20SQ9021", accessoryitem: "Seat Cover", quantity: "34", price: "$2000 ", purchasedate: "Thu Mar 2 2022" },
        { id: 12, vehicleno: "MH23MK8245", accessoryitem: "Cluch Wire", quantity: "13", price: "$2000", purchasedate: "Thu Mar 2 2022" },
        { id: 13, vehicleno: "MH24NF5321", accessoryitem: "Break Linear", quantity: "55", price: "$20000", purchasedate: "Thu Mar 2 2022" },
        { id: 14, vehicleno: "MH22PQ4441", accessoryitem: "Engine Oil", quantity: "12", price: "$2000", purchasedate: "Thu Mar 2 2022" },
        { id: 15, vehicleno: "MH12EE2323", accessoryitem: "Battery", quantity: "34", price: "$32525", purchasedate: "Thu Mar 2 2022" },
        { id: 30, vehicleno: "MH11FG9090", accessoryitem: "Oil Seal", quantity: "6", price: "$1000", purchasedate: "Thu Mar 2 2022" },
        { id: 17, vehicleno: "MH20UI1221", accessoryitem: "Speed Meter", quantity: "9", price: "$1000", purchasedate: "Thu Mar 2 2022" },
        { id: 18, vehicleno: "MH20EE0890", accessoryitem: "Tyer", quantity: "22", price: "$1000", purchasedate: "Thu Mar 2 2022" },
        { id: 19, vehicleno: "MH20SQ0987", accessoryitem: "Side Mirror", quantity: "21", price: "$2000", purchasedate: "Thu Mar 2 2022" },
        { id: 20, vehicleno: "MH21XQ0087", accessoryitem: "Side Mirror", quantity: "21", price: "$2000", purchasedate: "Thu Mar 2 2022" },


    ];


    return (
        <div className="vehicle-accessory-container my-4">

            <div className="special-header panel-white-all bg-white d-flex justify-content-between align-items-center mb-2">
                <h4 className="mb-0 page-title">Vehicle Accessory</h4>
                <div className="d-flex align-items-center gap-2">
                    <Link to="/createvehicleaccessory" type="button" className="btn custom-btn">Create Vehicle Accessory</Link>

                    <div className="dropdown">
                        <button id="btnGroupDropExport" type="button" className="btn custom-btn dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                            Export
                        </button>
                        <ul className="dropdown-menu" aria-labelledby="btnGroupDropExport">
                            <li><a className="dropdown-item" href="#">Save as PDF</a></li>
                            <li><a className="dropdown-item" href="#">Save as PNG</a></li>
                            <li><a className="dropdown-item" href="#">Save as CSV</a></li>
                            <li><a className="dropdown-item" href="#">Save as TXT</a></li>
                            <li><a className="dropdown-item" href="#">Save as XML</a></li>
                            <li><a className="dropdown-item" href="#">Save as SQL</a></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="table-top-filters d-flex flex-wrap gap-3">
       
                                <select className="form-select form-control-sm dropdrown-iteam"  style={{ maxWidth: "200px" }}>
                                    <option className="vehicle-dropdown">All</option>
                                    <option className="vehicle-dropdown">MH20EE3948</option>
                                    <option className="vehicle-dropdown">MH21RE4890</option>
                                </select>
                          
                                <input type="text" className="form-control form-control-sm" placeholder="Purchase Date"  style={{ maxWidth: "200px" }} />
                         
                           <button type="button" class="btn custom-btn">Clear</button>


            </div>

            <div className="card-body">

                <div className="table-responsive">
                    <table className="custom-table" style={{marginTop:'-1px'}}>
                        <thead>
                           
                            <tr>
                                <th style={{textAlign:'center'}}>Sr No</th>
                                <th style={{textAlign:'center'}}>Vehicle Name/Number</th>
                                <th style={{textAlign:'center'}}>Accessory Item</th>
                                <th style={{textAlign:'center'}}>Quantity</th>
                                <th style={{textAlign:'center'}}>price</th>
                                <th style={{textAlign:'center'}}>Purchase Date</th>
                                <th >Action</th>
                            </tr>

                        </thead>
                        <tbody>
                            {data.map((row) => (
                                <tr key={row.id}>
                                    <td style={{textAlign:'center'}}>{row.id}</td>
                                    <td style={{textAlign:'center'}}>{row.vehicleno}</td>
                                    <td style={{textAlign:'center'}}>{row.accessoryitem}</td>
                                    <td style={{textAlign:'center'}}>{row.quantity}</td>
                                    <td style={{textAlign:'center'}}>{row.price}</td>
                                    <td style={{textAlign:'center'}}>{row.purchasedate}</td>
                                    <td>
                                        <div className="btn-group">
                                            <button
                                                type="button"
                                                className="btn  btn-sm"
                                                onClick={() => handleNavigate(row.vehicleno)}
                                                title="View">
                                                <i class="bi bi-eye" style={{marginLeft:'-5px'}}></i>
                                            </button>
                                            <Link to="/accountant/updatevehicleaccessory"
                                                type="button"
                                                className="btn  btn-sm"
                                                title="Edit">
                                                <i className="bi bi-pencil-square" style={{marginLeft:'-5px'}}></i>
                                            </Link>
                                            <button
                                                type="button"
                                                className="btn  btn-sm"
                                                onClick={() => handleNavigate(row.buscode)}
                                                title="Delete">
                                                <i className="bi bi-trash3" style={{marginLeft:'-5px'}}></i>
                                            </button>
                                        </div>

                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>




    );
}
